module.exports = __webpack_public_path__ + "components/page-header/static/mountain-badge--dark-62ba8e9e747c3c45782f3490fa8e3907.svg";